import { useTable } from 'react-table'

import { Box, Table, TableCell, TableHead, TableRow } from '@mui/material'
import { NoData } from '@weberlo/components'

import './style.css'

const EmptyTable = ({ columns, data, sx }: any) => {
  const { getTableProps, headerGroups } = useTable({
    columns,
    data,
  })

  return (
    <Box
      sx={{
        borderRadius: '16px',
        border: '1px solid var(--mui-palette-primary-light)',
        ...sx,
      }}>
      <Table {...getTableProps()}>
        <TableHead>
          {headerGroups.map(headerGroup => (
            <TableRow
              className="header-styling"
              {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column: any) => (
                <TableCell
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                      width: column.width || 'auto',
                    },
                  ])}>
                  {column.render('Header')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
      </Table>
      <NoData />
    </Box>
  )
}

export default EmptyTable
